"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M7.705 22.134c1.338.578 2.77.866 4.295.866 1.526 0 2.957-.288 4.295-.866a11.1 11.1 0 0 0 3.49-2.35 11.095 11.095 0 0 0 2.35-3.49C22.71 14.958 23 13.527 23 12c0-1.526-.288-2.957-.866-4.295a11.1 11.1 0 0 0-2.35-3.49 11.1 11.1 0 0 0-3.49-2.35A10.723 10.723 0 0 0 12 1c-1.526 0-2.957.289-4.295.866a11.1 11.1 0 0 0-3.49 2.35 11.1 11.1 0 0 0-2.35 3.49A10.723 10.723 0 0 0 1 12c0 1.526.289 2.957.866 4.295a11.1 11.1 0 0 0 2.35 3.49 11.1 11.1 0 0 0 3.49 2.35Zm3.777-10.707c-1.038 1.006-1.177 1.687-1.007 2.817h1.61c-.072-.994.433-1.412 1.253-2.089l.187-.155c1.006-.82 1.578-1.548 1.578-2.724 0-1.858-1.284-2.802-3.405-2.802-1.192 0-2.09.34-2.801.82v1.672h.866c.403-.418.96-.727 1.796-.727.665 0 1.16.356 1.16 1.052 0 .836-.556 1.47-1.237 2.136Zm-1.394 4.86c0 .697.558 1.239 1.27 1.239.696 0 1.269-.542 1.269-1.238 0-.697-.573-1.254-1.27-1.254-.711 0-1.269.557-1.269 1.254Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};